import gql from 'graphql-tag';

export default gql`
    mutation SaveYard($input: SaveYardInput) {
        saveYard(input: $input) {
            errors
        }
    }
`;
